/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, Col, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import SVG from "react-inlinesvg";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  StatusFormatter,
  formatCurrency,
  attachFormatter,
} from "../../../utility";
import { setRtv } from "./withrtvSlice";

export const WithRtvNonRefTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  deleteRow,
  rtv,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        customerName: rtv.customerName,
        customerCode: rtv.customerCode,
        salesDivision: rtv.salesDivision,
        distributionChannel: rtv.distributionChannel,
        plantCode: rtv.plantCode,
        returnId: rtv.returnId,
        rtvNo: rtv.rtvNo,
        rtvDate: rtv.rtvDate,
        rtvReceivingDate: rtv.rtvReceivingDate,
        remarksRtv: rtv.remarksRtv,
      };
    });

    setTableData(initData);
  }, [data, sizePerPage, page]);

  //ref to bind this fuker
  //https://stackoverflow.com/questions/59121058/react-hook-updates-parent-state-a-step-behind
  const handleDeleteChangeData = (column) => {
    const idColumn = column.uuid;
    setUid(idColumn);
  };

  const [uid, setUid] = useState("");

  useEffect(() => {
    deleteRow(uid, data);
  }, [uid]);
  // this fuker bug stop here

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const columns = [
    {
      text: "Action",
      dataField: "action",
      editable: false,

      formatter: (cell, column, formatExtraData) => {
        return (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm"
              onClick={() => handleDeleteChangeData(column, cell)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        );
      },
    },
    { text: "uuid", dataField: "uuid", hidden: true },
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "materialCode" },
    { text: "Material Description", dataField: "materialName" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },

    {
      text: "CRPRGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
    },
    {
      text: "NRA",
      dataField: "nra",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Batch",
      dataField: "batch",
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: formatDate,
      align: "center",
    },
    {
      text: "Exclusion Status",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
  ];

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="ID"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4">
        <Col sm={1}>
          <Button
            variant="success"
            onClick={() => {
              dispatch(setRtv(tableData));
              history.push(`/new-return/with-rtv/non-ref`);
            }}
          >
            Next
          </Button>
        </Col>
        <Col sm={1}>
          <Button variant="outline-danger" onClick={() => history.push("/")}>
            Back
          </Button>
        </Col>
      </Row>
    </>
  );
};
